/**
 * Boarding-pass style fare card.
 * Used for the 4 service tiers on How It Works.
 */
export default function FareCard({
  route,
  routeSub,
  klass,
  name,
  forText,
  desc,
  price,
  priceSub,
  cta,
  href,
  dark = false,
  testid,
}) {
  return (
    <article
      data-testid={testid}
      className={`relative flex flex-col border transition-transform duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_24px_50px_-22px_rgba(20,18,16,.22)] ${
        dark ? "bg-navy border-navy-mid text-white" : "bg-white border-line text-ink"
      }`}
    >
      {/* TOP */}
      <div className="flex items-start justify-between gap-3.5 px-7 sm:px-8 pt-7 pb-5">
        <div className={`font-mono text-[19px] sm:text-[21px] tracking-[0.06em] flex items-center gap-3 ${dark ? "text-white" : "text-ink"}`}>
          <span>{route}</span>
          <small
            className={`block font-mono text-[8.5px] tracking-[0.2em] uppercase mt-1 ${
              dark ? "text-white/30" : "text-ink-low"
            }`}
            style={{ marginLeft: 6 }}
          >
            {routeSub}
          </small>
        </div>
        <div className="font-mono text-[9px] tracking-[0.2em] uppercase text-coral border border-coral px-2.5 py-[5px] whitespace-nowrap">
          {klass}
        </div>
      </div>

      {/* Perforation */}
      <div className={`perf ${dark ? "perf-dark" : ""}`} />

      {/* BODY */}
      <div className="px-7 sm:px-8 pt-6 pb-7 flex-1 flex flex-col">
        <h3 className={`font-serif-i italic text-[28px] sm:text-[30px] tracking-[-.028em] leading-none mb-2.5 ${dark ? "text-white" : "text-ink"}`}>
          {name}
        </h3>
        <p className={`text-[13.5px] font-medium mb-2 ${dark ? "text-white" : "text-ink"}`}>
          {forText}
        </p>
        <p className={`text-[13px] font-light leading-[1.72] mb-5 ${dark ? "text-white/55" : "text-ink-muted"}`}>
          {desc}
        </p>

        <div className={`mt-auto pt-4 flex items-end justify-between gap-3.5 border-t ${dark ? "border-white/15" : "border-line"}`}>
          <div>
            <p className={`font-serif-i italic text-[28px] sm:text-[30px] tracking-[-.03em] leading-[.9] ${dark ? "text-white" : "text-ink"}`}>
              {price}
            </p>
            <p className={`font-mono text-[9px] tracking-[0.14em] uppercase mt-1.5 ${dark ? "text-white/35" : "text-ink-low"}`}>
              {priceSub}
            </p>
          </div>
          <a
            href={href}
            data-testid={`${testid}-cta`}
            className={`font-medium text-[13px] whitespace-nowrap pb-[3px] border-b-[1.5px] border-coral transition-colors hover:text-coral ${
              dark ? "text-white" : "text-ink"
            }`}
          >
            {cta}
          </a>
        </div>
      </div>
    </article>
  );
}
